import React from 'react';
import { NavLink } from 'react-router-dom';
import './BottomBar.css';

const BottomBar = () => {
  const menuItems = [
    {
      path: '/admin/accettazione',
      icon: 'fas fa-clipboard-check',
      label: 'Accettazione'
    },
    {
      path: '/admin/formula',
      icon: 'fas fa-calendar-alt',
      label: 'Formula'
    },
    {
      path: '/admin/partite',
      icon: 'fas fa-futbol',
      label: 'Partite'
    },
    {
      path: '/admin/statistiche',
      icon: 'fas fa-chart-bar',
      label: 'Statistiche'
    },
    {
      path: '/admin/tornei',
      icon: 'fas fa-trophy',
      label: 'Tornei'
    },
    {
      path: '/admin/edizioni',
      icon: 'fas fa-bars',
      label: 'Edizioni'
    },
    {
      path: '/admin/utenti',
      icon: 'fas fa-user',
      label: 'Utenti'
    }
  ];

  return (
    <div className="bottom-bar">
      <div className="bottom-bar-container">
        {menuItems.map((item, index) => (
          <NavLink
            key={index}
            to={item.path}
            className={({isActive}) => `bottom-bar-item ${isActive ? 'active' : ''}`}
          >
            <div className="bottom-bar-icon">
              <i className={item.icon}></i>
            </div>
            <span className="bottom-bar-label">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default BottomBar;